export default __webpack_public_path__ + "static/media/bolivia.c6fe59ad.png";